<template>
  <q-dialog ref="dialogRef" persistent @hide="onDialogHide">
    <q-card class="q-dialog-plugin q-pa-sm" style="max-width: inherit">
      <!-- No max width, adapt dialog to the size of text-->
      <q-item>
        <q-item-section avatar>
          <q-avatar icon="fa-duotone fa-alarm-exclamation" color="primary" text-color="white" />
        </q-item-section>
        <q-item-section>
          <div class="q-pl-sm text-blue-10 col">
            <template v-if="!sessionExpired">
              <div class="text-body1">
                {{ t('user.session.soonExpired') }}
              </div>
              <div class="text-body2">
                {{ t('user.session.timer', { remainingTime: sessionRemainingTime }) }}
              </div>
            </template>
            <template v-else>
              <div class="text-center text-h6">
                {{ t('user.session.expired') }}
              </div>
            </template>
          </div>
        </q-item-section>
      </q-item>

      <q-card-actions align="right">
        <template v-if="!sessionExpired">
          <q-btn
            flat :label="t('user.session.extend')" color="primary" :loading="loggingIn"
            @click.stop="onTryRefreshSession"
          />
          <q-btn
            flat :label="t('common.disconnect')" color="secondary" :loading="loggingOut"
            @click.stop="onLogout"
          />
        </template>
        <template v-else>
          <q-btn
            flat :label="t('common.reconnect')" color="secondary" :loading="loggingIn"
            @click.stop="onTryRefreshSession"
          />
        </template>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { ref, toRefs } from 'vue'
  import { useDialogPluginComponent } from 'quasar'
  import { useI18n } from 'vue-i18n'
  import { useAuth } from 'src/modules/core/composables/useAuth.js'

  const { onLogout, loggingOut } = useAuth()
  const { t } = useI18n()

  const loggingIn = ref(false)

  const props = defineProps({
    sessionKeepAliveHandler: Function,
    sessionExpired: Boolean,
    sessionRemainingTime: Number
  })
  defineEmits([
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits
  ])
  const { sessionExpired, sessionRemainingTime } = toRefs(props)

  const {
    dialogRef,
    onDialogHide,
    onDialogOK
  } = useDialogPluginComponent()

  async function onTryRefreshSession() {
    loggingIn.value = true

    if (await props.sessionKeepAliveHandler()) {
      loggingIn.value = false
      onDialogOK()
    } else {
      window.location.reload()
    }
  }
</script>
